module.exports = __webpack_public_path__ + "static/homepage-1-2-c9617f87f3e80483e8ee3e4cb4e1fbe0.png";